import React, { useState } from "react";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../components/ButtonIcon/ButtonIcon";
import CaretRight from "../../../../../../assets/svg/icons/common/CaretRight";
import ChildTable from "./child-table";
import { formatCurrency } from "../../../../../../../components/helper/helper";
import DropDown from "../../../../../../components/DropDown/DropDown";
import TrendUp from "../../../../../../assets/svg/icons/common/TrendUp";
import TrendDown from "../../../../../../assets/svg/icons/common/TrendDown";
import Avatar from "../../../../../../components/Avatar/Avatar";
import PlaceholderLogoIcon from "../../../../../../assets/svg/icons/common/placeholder-logo";
import KebabDots16 from "../../../../../../assets/svg/icons/common/KebabDots16";

function Row({ data, handleAddMember, handleRemoveMember, updateMemberStatus, handleEditSubOrg }) {
  const [isOpen, setIsOpen] = useState(false);

  const sub_org_drop_down_options = [
    {
      text: "Edit",
      type: "normal",
      onClick: () => {
        handleEditSubOrg(data?.id);
      },
    },
    {
      text: "Add Member",
      type: "normal",
      onClick: () => {
        handleAddMember(data?.id);
      },
    },
    // No suborg delete presen in v1
    // {
    //   text: "Delete Sub-Organization",
    //   type: "danger",
    //   onClick: () => {
    //     handleDeleteSubOrg(data?.id);
    //   }
    // },
  ];

  const volume = data?.mtd_processing_volume
    ? `$${Number(data?.mtd_processing_volume).toLocaleString()}`
    : "$0";

  const getTrendIcon = () => {
    const volumeValue = data?.mtd_processing_volume || 0;
    
    if (volumeValue === 0 || !data?.mtd_volume_trend) {
      return null;
    }
    
    return data.mtd_volume_trend === 'up' ? <TrendUp /> : <TrendDown />;
  };

  return (
    <>
      <tr className={style.table_row}>
        <td className={style.table_cell}>
          {data?.members?.length > 0 ? (
            <ButtonIcon
              bgColor={"#FF"}
              onClick={() => {
                setIsOpen(!isOpen);
              }}
              className={`${isOpen ? style.collapse_button : ""}`}
            >
              <CaretRight />
            </ButtonIcon>
          ) : (
            <div style={{ width: '32px' }}></div>
          )}
        </td>
        <td className={`${style.table_cell} ${style.orgNameCell}`}>
          <div className={style.orgNameCellImage}>
            { data?.logo_path ? (<img src={data?.logo_path} alt="" />) : (<PlaceholderLogoIcon />) }            
          </div>
          <span className={style.orgName}>{data?.name}</span>
        </td>
        <td className={style.table_cell}>$ {data?.mtd_processing_volume ? formatCurrency(data?.mtd_processing_volume) : 0}</td>
        <td className={style.table_cell}>{data?.open_applications?.percentage}% ({data?.open_applications?.count}) </td>
        <td className={style.table_cell}>{data?.chargeback?.percentage}% (${data?.chargeback?.amount ? formatCurrency(data?.chargeback?.amount) : 0}) </td>
        <td className={style.table_cell}>{data?.non_active_accounts?.percentage}% ({data?.non_active_accounts?.count}) </td>
        <td className={style.table_cell}>{data?.approved?.percentage}% ({data?.approved?.count}) </td>
        <td className={style.table_cell}>{data?.member_count} </td>
        <td className={style.table_cell}> 
            <DropDown options={sub_org_drop_down_options}>
              <KebabDots16 />
            </DropDown>
        </td>
      </tr>
      {isOpen && data?.members?.length > 0 && <ChildTable data={data?.members} handleRemoveMember={handleRemoveMember} updateMemberStatus={updateMemberStatus} />}
    </>
  );
}

export function MobileCard({ data, handleAddMember, handleRemoveMember, updateMemberStatus, onOpenDetail }) {
  const [isOpen, setIsOpen] = useState(false);

  const volume = data?.mtd_processing_volume
    ? `$${Number(data?.mtd_processing_volume).toLocaleString()}`
    : "$0";

  const getTrendIcon = () => {
    const volumeValue = data?.mtd_processing_volume || 0;

    if (volumeValue === 0 || !data?.mtd_volume_trend) {
      return null;
    }

    return data.mtd_volume_trend === "up" ? <TrendUp /> : <TrendDown />;
  };

  const handleCaretClick = (e) => {
    e.stopPropagation();
    if (data?.members?.length > 0) setIsOpen((prev) => !prev);
  };

  const handleCardClick = () => {
    if (onOpenDetail) {
      onOpenDetail(data);
    } else if (data?.members?.length > 0) {
      setIsOpen((prev) => !prev);
    }
  };

  return (
    <div className={style.mobile_card}>
      <div className={style.mobile_card_content} onClick={handleCardClick}>
        <div className={style.mobile_card_left}>
          {data?.members?.length > 0 ? (
            <div
              className={`${style.mobile_card_chevron} ${isOpen ? style.chevron_open : ""}`}
              onClick={handleCaretClick}
              role="button"
              aria-expanded={isOpen}
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleCaretClick(e);
                }
              }}
            >
              <CaretRight />
            </div>
          ) : (
            <div style={{ width: "24px" }} />
          )}
          <div className={style.mobile_card_name}>{data?.name}</div>
        </div>
        <div className={style.mobile_card_right}>
          <div className={style.mobile_card_volume}>{volume}</div>
          <div className={style.mobile_card_trend}>{getTrendIcon()}</div>
        </div>
      </div>
      {isOpen && data?.members?.length > 0 && (
        <div className={style.mobile_card_members}>
          {data.members.map((member, index) => {
            const isEnabled = member.disabled === 0;
            const isLast = index === data.members.length - 1;
            return (
              <div key={member.id} className={style.mobile_card_member}>
                <div className={style.mobile_card_connector}>
                  <svg width="17" height="25" viewBox="0 0 17 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 0V16C1 20.4183 4.58172 24 9 24H17" stroke="#C1C1DD" strokeWidth="2"/>
                  </svg>
                </div>
                <Avatar name={member.name?.charAt(0).toUpperCase()} />
                <span className={style.mobile_card_member_name}>{member.name}</span>
                <div className={style.mobile_card_member_status}>
                  <span className={`${style.status_dot} ${isEnabled ? style.status_enabled : style.status_disabled}`}></span>
                  <span>{isEnabled ? "Enabled" : "Disabled"}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default Row;
